import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import { Container, Typography, List, ListItem, ListItemText, Paper } from '@mui/material';

const DeviceLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      const { data, error } = await supabase.from('device_logs').select('*');
      if (error) {
        setError(error.message);
      } else {
        setLogs(data);
      }
      setLoading(false);
    };
    fetchLogs();
  }, []);

  if (loading) {
    return (
      <Container className="py-6">
        <Typography variant="h5" className="text-center font-sans">Loading...</Typography>
      </Container>
    );
  }

  return (
    <Container className="py-6">
      <Typography variant="h4" className="font-sans text-primary mb-4 text-center">
        Device Logs
      </Typography>
      {error && (
        <Typography color="error" className="mb-4 text-center">{error}</Typography>
      )}
      <Paper elevation={3} className="p-4 overflow-auto max-h-[60vh] rounded-md shadow-md">
        <List dense>
          {logs.map((log) => (
            <ListItem key={log.id} divider>
              <ListItemText
                primary={`Device event at ${new Date(log.timestamp).toLocaleString()}`}
                secondary={log.details || ''}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
};

export default DeviceLog;
